import { render, staticRenderFns } from "./group_view.vue?vue&type=template&id=17a4d3fe&scoped=true"
import script from "./group_view.vue?vue&type=script&lang=js"
export * from "./group_view.vue?vue&type=script&lang=js"
import style0 from "./group_view.vue?vue&type=style&index=0&id=17a4d3fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a4d3fe",
  null
  
)

export default component.exports